var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box"},[_c('span',{staticClass:"map-box-span",on:{"click":_vm.back}},[_vm._v("返回")]),_c('iframe',{staticStyle:{"width":"100%","height":"calc(100vh - 92px)"},attrs:{"src":"https://aoyunltd.com/jyb_map","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }